import React from 'react'
import { LoadingIndicator } from 'components/loading'
import { useStyles } from './loadingPageContent.css'

const LoadingPageContent = (props) => {
  const classes = useStyles()

  return <div className={classes.root}><LoadingIndicator />{props.text && <div className={classes.text}>{props.text}</div>}</div>
}

export {
  LoadingPageContent
}